import {AfterViewInit, Component, OnInit} from '@angular/core';
import {
    ControlService,
    IconService,
    SubtitlesService,
    TimeDateService
} from "../../../core";
import {MenuType} from "../../../models";

@Component({
    selector: 'date-interval',
    templateUrl: './date-interval.component.html',
    styleUrls: ['./date-interval.component.scss']
})
export class DateIntervalComponent  implements OnInit, AfterViewInit {
    newDateStart: string = '';
    newDateEnd: string = '';

    constructor(
        public control: ControlService,
        private icon: IconService,
        private subtitles: SubtitlesService,
        public timeDate: TimeDateService,
    ) {
    }

    ngOnInit() {
        this.timeDate.setDatePickers();
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    duringChange(): 't' | 'f' {
        const menuElement = this.control.elementVal.getValue();

        return menuElement?.duringChange === 't' ? 't' : 'f';
    }

    changeDateStart(date: string): void {
        this.timeDate.dateStart = date;
        this.timeDate.changeDate('start');
        this.newDateStart = this.timeDate.dateStart;
        this.newDateEnd = this.timeDate.dateEnd;
    }


    changeDateEnd(date: string): void {
        this.timeDate.dateEnd = date;
        this.timeDate.changeDate('end');
        this.newDateStart = this.timeDate.dateStart;
        this.newDateEnd = this.timeDate.dateEnd;
    }
}
